/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Deals_DescriptionInputs */

const en_directory_hubs_deals_description = /** @type {(inputs: Directory_Hubs_Deals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Founder-posted discount codes and free offers from products in the directory.`)
};

const zh_directory_hubs_deals_description = /** @type {(inputs: Directory_Hubs_Deals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由创始人发布的目录产品折扣码和免费优惠。`)
};

/**
* | output |
* | --- |
* | "Founder-posted discount codes and free offers from products in the directory." |
*
* @param {Directory_Hubs_Deals_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_deals_description = /** @type {((inputs?: Directory_Hubs_Deals_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Deals_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_deals_description(inputs)
	return zh_directory_hubs_deals_description(inputs)
});
export { directory_hubs_deals_description as "directory.hubs.deals.description" }